import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import parserFilters from '@/utils/parserFilters'

const model = (payload) => ({
  // columns
  id: payload.id
})
var crud = new Crud('Manufacturings', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  catalog: {
    taxReceipts: []
  },
  manufacturings: [],
  productionStatus: {},
  productionAreas: {},
  sub_total: 0,
  total_amount: 0,
  products: []
}

const mutations = {
  ...crud.mutations,
  SET_PRODUCTION_STATUS (state, payload) {
    state.productionStatus = payload.data
  },
  SET_PRODUCTION_AREA (state, payload) {
    state.productionAreas = payload.data
  },
  SET_SUB_TOTAL_AMOUNT (state, payload) {
    state.sub_total = payload.reduce((sum, t) => sum + t.total_import, 0)
  },
  SET_TOTAL_AMOUNT (state, payload) {
    state.total_amount = (state.sub_total * (payload[0].purchase_order.tax_type / 100)) + state.sub_total
  },
  SET_SELECTED_PRODUCTS (state, payload) {
    state.products = [...payload]
  }
}

const actions = {
  ...crud.actions,
  async loadRecordsManufacture ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`customer-purchase-order-details?page=${payload.page}${state.filterParams}&${payload.param}`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.products', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_RECORDS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadProductionStatus ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`production-statuses`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
      } else {
        commit('SET_PRODUCTION_STATUS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadProductionArea ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`production-areas`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
      } else {
        commit('SET_PRODUCTION_AREA', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async updateStatus ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`customer-purchase-order-details/${payload.id}`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
      } else {
        commit('UPDATE_RECORD', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.manufacturing', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  applyFilterManufacture ({ commit }, payload) {
    const filter = parserFilters(payload)
    commit('SET_FILTER_PARAMS', filter)
  },
  clearFilterManufacture ({ commit }, payload) {
    const filter = ''
    commit('SET_FILTER_PARAMS', filter)
  },
  setSubTotal ({ commit }, payload) {
    commit('SET_SUB_TOTAL_AMOUNT', payload)
  },
  setTotalAmount ({ commit }, payload) {
    commit('SET_TOTAL_AMOUNT', payload)
  },
  async createInvoice ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.post(`invoices`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.invoice', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  exportManufature ({ dispatch }, payload) {
    dispatch('CustomerPurchaseOrderDetails/exportRecords', payload, { root: true })
  },
  setSelectedProducts ({ commit }, payload) {
    commit('SET_SELECTED_PRODUCTS', payload)
  },
  async editProduct ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`customer-purchase-order-details/${payload.id}`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_RECORD', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.product', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  ...crud.getters,
  manufacturings: state => state.manufacturings,
  productionStatus: state => state.productionStatus,
  productionAreas: state => state.productionAreas,
  sub_total: state => state.sub_total,
  total_amount: state => state.total_amount,
  products: state => state.products
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
